<template>
  <div class="simple-select">
    <button
      class="btn justify-start"
      :class="{ focus: isModalShow }"
      :style="{ width: `${buttonWidth}` }"
      @click="isModalShow = !isModalShow"
    >
      <span
        v-if="selectedValue === null || isOnlyShowButtonPlaceholder"
        :class="{ 'ink-01-emphasis--text': isModalShow }"
        >{{ buttonPlaceholder }}</span
      >
      <span v-else class="ink-01-emphasis--text">{{ textOnButton }}</span>
      <v-icon class="ml-auto">arrow_drop_down</v-icon>
    </button>
    <div
      v-if="isModalShow"
      class="simple-select__modal block block-3"
      :style="{ width: `${modalWidth}`, top: `${modalTop}` }"
    >
      <div
        class="simple-select__body"
        :style="{ 'max-height': `${modalBodyHeight}` }"
      >
        <div
          v-for="item in options"
          :key="item.value"
          class="simple-select__item selection-item-hover"
          @click="selectItem(item)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Zeplin: https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f0d0f46402f527e308cf261

export default {
  props: {
    buttonPlaceholder: {
      type: String,
      default: '篩選項目',
    },
    buttonWidth: {
      type: String,
      default: '160px',
    },
    isOnlyShowButtonPlaceholder: {
      type: Boolean,
      default: false,
    },
    modalWidth: {
      type: String,
      default: '360px',
    },
    modalBodyHeight: {
      type: String,
      default: '408px',
    },
    modalTop: {
      type: String,
      default: 'auto',
    },
    selectedValue: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default: () => [
        {
          value: 1,
          title: 'option1',
        },
      ],
    },
    limitOfWordLengthInInput: {
      type: Number,
      default: 14,
    },
  },
  data() {
    return {
      isModalShow: false,
      selectItemValue: null,
    };
  },
  created() {
    this.selectItemValue = this.options.find((o) => o.value === this.selectedValue);
  },
  computed: {
    textOnButton() {
      const { selectItemValue } = this;
      if (!selectItemValue) {
        return null;
      }
      return selectItemValue.title.length < this.limitOfWordLengthInInput
        ? selectItemValue.title
        : `${selectItemValue.title.slice(0, 10)}...`;
    },
  },
  methods: {
    selectItem(item) {
      this.$emit('update:selectedValue', item.value);
      this.selectItemValue = item;
      this.isModalShow = false;
    },
  },
};
</script>

<style lang="scss">
.simple-select {
  position: relative;

  &__modal {
    position: absolute;
    margin-top: 5px;
    z-index: 1;
    background-color: #fff;
  }
  &__head {
    padding: 10px;
    box-shadow: inset 0 -1px 0 0 #d7dee7;
  }

  &__body {
    overflow: auto;
  }
  &__item {
    display: flex;
    align-items: center;
    height: 48px;
    padding-left: 10px;
    font-size: 14px;
    line-height: 1.43;
    cursor: pointer;
  }
}
</style>
